import * as React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useEffect } from 'react';

import { AppContainer } from 'components/common/appContainer';
import { ControlledTextInput } from 'components/common/ControlledTextInput';
import { useAppStore } from 'core/store/app/useAppStore';
import { useCreateRequirement } from 'hooks/useCreateRequirement';
import { userRolesPermissions } from 'core/constants/userRolesPermissions';
import { UserRightsContainer } from 'components/common/UserRightsContainer';

const CreateRequirement = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const urlSearchParams = new URLSearchParams(location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    const setErrorAlertText = useAppStore((state) => state.setErrorAlertText);
    const { createRequirement, event } = useCreateRequirement(params.eventId, params.riskId);

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors, isValid },
    } = useForm({
        defaultValues: { text: '' },
        shouldUseNativeValidation: false,
    });

    useEffect(() => {
        if (event) {
            setValue('text', event.eventText);
        }
    }, [event]);

    const onSave = (): void => {
        if (!isValid) {
            setErrorAlertText('Заполните все поля формы.');
        }
    };

    const onSubmit: SubmitHandler<{ text: string }> = (data) => {
        setErrorAlertText('');
        createRequirement(data);
    };

    const onCancel = (): void => {
        navigate(-1);
    };

    return (
        <AppContainer>
            <UserRightsContainer allowedUserRoles={userRolesPermissions.requirements.create}>
                <div className={'container_thin'}>
                    <h2>Создание нового требования</h2>
                    <form noValidate onSubmit={handleSubmit(onSubmit)}>
                        <ControlledTextInput
                            name={'text'}
                            control={control}
                            label={'Текст требования'}
                            error={!!errors.text}
                            required
                            multiline
                        />
                        <Box sx={{ display: 'flex', marginBottom: 4, marginTop: 2 }}>
                            <Box mr={'10px'}>
                                <Button variant="contained" type={'submit'} onClick={onSave}>
                                    Сохранить требование
                                </Button>
                            </Box>
                            <Box mr={'10px'}>
                                <Button variant="outlined" onClick={onCancel}>
                                    Отменить
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </div>
            </UserRightsContainer>
        </AppContainer>
    );
};

export { CreateRequirement };
